/**
 * Backoffice order-request API base path (relative to `REACT_APP_API_BASE_URL`, e.g. /api/v1).
 * @see POST/GET /api/v1/backoffice/order-request, etc.
 */
export const BACKOFFICE_ORDER_REQUEST = "backoffice/order-request";
